<template>
  <div class="main" style="min-height: 1000px">
    <img src="/checkin/backgroud_top.jpg" style="width: 100%; height: auto">
    <div>
      <div >
<!--        <h1>議程資料</h1>-->
        <table class="table table-hover">
          <tbody>
          <tr>
            <td >{{formData.Name}}</td>
          </tr>
          <tr>
            <td width="200px">
              <div v-if="formData.Type===CheckIn_EventItemType_Open">
                開放型(不需預先報名)
              </div>
              <div v-else-if="formData.Type===CheckIn_EventItemType_NeedReg">
                需先報名
              </div>
              <div v-else>
                XX:{{item.Type}}
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <h3>回覆資訊</h3>

        <div v-if="formData.Question1" class="question">
          問題1 {{ formData.Question1}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question1Answer" :option-token-str="formData.Question1Options" token-str=","></MyRadioWithTokenStr>
        </div>
        <hr>
        <div v-if="formData.Question2" class="question">
          問題2 {{ formData.Question2}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question2Answer" :option-token-str="formData.Question2Options" token-str=","></MyRadioWithTokenStr>
        </div>
        <hr>
        <div v-if="formData.Question3" class="question">
          問題3 {{formData.Question3}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question3Answer" :option-token-str="formData.Question3Options" token-str=","></MyRadioWithTokenStr>
        </div>


<!--        <a role="button" class="btn btn-primary" @click="btnCheckIn" >確認報到</a>-->
        <a role="button" class="btn btn-primary" href="#" @click="btnCheckIn" v-if="memberUUID && CanCheckIn">確認報到</a>
      </div>
    </div>
    <img src="/checkin/backgroud_footer.jpg" style="width: 100%; height: auto">
  </div>
</template>

<script>
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import util from "@/util/util";
import checkInDeclare from "@/views/checkInAdmin/js/checkInDeclare";
import MyRadioWithTokenStr from "@/views/taylorAdmin/component/MyRadioWithTokenStr";
/**

 **/


export default {
  components: {MyRadioWithTokenStr},
  //name: "index",
  // props: [""],
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      memberUUID:"",
      msg:"",
      EventSystemId:"",
      EventItemSystemId:"",

      Question1Answer:"",
      Question2Answer:"",
      Question3Answer:"",

      CanCheckIn:true,
    };
  },
  methods: {
    async loadData() {
      this.memberUUID=checkInDeclare.GetLocalMemberId();

      if (this.memberUUID){
        let that=this;

        let loader=util.ShowLoading(this);

        apiCheckIn.api_Event_Get(this.EventSystemId).then((data)=>{
          let event=apiAdmin.initReturnObjectWithTemplate(data.data.data,this.formData);

          event.EventItems.forEach((eventItem)=>{
            if (eventItem.SystemId===that.EventItemSystemId){
              that.formData=eventItem;
            }
          });

          apiCheckIn.api_Client_CheckMemberCanCheckIn(that.EventSystemId,that.EventItemSystemId, that.memberUUID).then((dataCheckIn)=>{
            let msg=dataCheckIn.data.data;

            that.CanCheckIn=msg;

            if (!that.CanCheckIn){
              alert("抱歉，您不在會議名單中 請與主辦單位核對")
            }
            util.HideLoading(loader);
          });
        });
      }else{
        alert("訊息:請用相機，掃描您名牌上的QR Code");
      }
    },
    btnCheckIn(){
      // let that=this;
      let loader=util.ShowLoading(this);

      apiCheckIn.api_Client_ScanEventItem(this.memberUUID,this.EventSystemId,this.EventItemSystemId,"user",this.Question1Answer,this.Question2Answer,this.Question3Answer).then((data)=>{
        let msg=data.data.data;
        // that.EventSystemId=that.formData.EventSystemId;

        if (msg){
          alert(msg)
        }else{
          alert('報到成功')
        }

        util.HideLoading(loader);
      });
    }
    // btnGotoScanCode(){
    //   if (this.memberUUID) {
    //     this.$router.push({name: 'CheckInClientScanCode', query: {Member: this.formData}})
    //   }else{
    //     alert('訊息:請用相機，掃描您名牌上的QR Code')
    //   }
    // }
  },
  mounted() {
    //this.loadData()
    let eventId=this.$route.query.eventId;
    let eventItemId=this.$route.query.eventItemId;

    this.EventSystemId=eventId;
    this.EventItemSystemId=eventItemId;

    this.loadData();

  },
}
</script>

<style scoped>
h1 {
  color:#fefe02;
}
h3{
  color:#fefe02;
}
.main{
  /*background-image: url("/checkin/background0.jpg");*/
  /*!*background-position: center;*!*/
  /*background-repeat: no-repeat;*/
  /*background-size: cover;*/

  background-color: #00375e;
}
.table{
  color:#fefe02;
  background-color:#00375e;
  border-color:#00375e;
}

.question {
  color:#fefe02;
  margin-left: 30px;
}

</style>
